import script from "./NotificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationsPage.vue?vue&type=style&index=0&id=bf605eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf605eb8"]])

export default __exports__